import { useEffect, useState } from "react";
import { ReqDetail, updateCompanyRed } from "../../../api/LeaderPortalApi";
import { notify } from "../../utils";
import { RightArrowGrey } from "../../icons/RightArrow";
import { HeaderOfDetail } from "../../utils/HeaderOfLeaderPortal";
import { CompanyHeaderReq, UserHeaderReq } from "../../icons/HeaderIcons";
import CompanyField from "./CompanyField";
import { FormProvider, useForm } from 'react-hook-form';
import { Toaster } from "react-hot-toast";
import { ChangeTransactionStatusPaid, EkycDonePopUp, EkycDoneReset } from "../PersonalityRequest/EkycDonePopUp";
import { encryptAES } from "../../utils/encryption";
import { setUniqueData, setTimeStamp } from "../../redux/actions/FirstInfoAction";
import { useSelector, useDispatch } from "react-redux";
import forge from 'node-forge';
export default function DetailCompanyRequest({ setDetailId, detailId }) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState("")
    const [transactionId, setTransactionId] = useState("")
    const [transactionStatus, setTransactionStatus] = useState("")
    const [encryptedData, setEncryptedData] = useState(useSelector(state => state.FirstInfo.uniqueData));
    const [stampTime, setStampTime] = useState(useSelector(state => state.FirstInfo.timeStamp));
    const [openModal, setOpenModal] = useState(false)
    const [openModalStatus, setOpenModalStatus] = useState(false)
    const [openModalReset, setOpenModalReset] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)
    const methods = useForm();

    const warningLeader = [
        "حتما شناسه ملی سازمان را چک کنید معتبر باشد و وضعیت سازمان در حال تسویه نباشد.",
        "نام انگلیسی شرکت حتما به انگلیسی باشد و شامل عدد ، حروف فارسی و علامت خاصی نباشد.",
        "تصاویر آپلود شده توسط شرکت حتما بررسی شود و صحت ان چک شود.",
        "شناسه ملی شرکت اعداد فارسی نباشد.",
        "قبل از تایید احراز هویت تصویر مدارک کاربر چک شود و چهره کاربر به صورت مجازی دیده شود."
    ];

    const downloadCsrAsTxt = (nationalId, certificate) => {
        let downloadName = '';
        let newTimeStamp = '';
        let newEncryptedData = '';
        if (encryptedData != '' && encryptedData != null && encryptedData != undefined && stampTime != '' && stampTime != undefined && stampTime != null) {
            downloadName = nationalId + `_${stampTime}` + `_${encryptedData}` + '_certificate.crt';
        } else {
            newTimeStamp = Date.now();
            newEncryptedData = encryptAES(nationalId, newTimeStamp);
            setEncryptedData(newEncryptedData);
            setStampTime(newTimeStamp);
            dispatch(setUniqueData({uniqueData:newEncryptedData}));

            dispatch(setTimeStamp({timeStamp:newTimeStamp}))
            downloadName = nationalId + `_${newTimeStamp}` + `_${newEncryptedData}` + '_certificate.crt';
        }
    
   

        const txtContent = new Blob([certificate ? certificate : ''], { type: 'text/plain' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(txtContent);
        a.download = downloadName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
    };

    useEffect(() => {
        setIsLoading(true)
        ReqDetail(detailId).then(response => {
            setIsLoading(false)
            setData(response?.data)
            setTransactionId(response?.data?.transactionId)
            setTransactionStatus(response?.data?.transactionStatus);
        }).catch(error => {
            setIsLoading(false)
            notify(error?.response?.data?.message)
        })
    }, [loadingPage])

    const onSubmit = methods.handleSubmit(dataToSend => {
        setIsLoading(true)

        updateCompanyRed(dataToSend, transactionId).then(response => {
            setIsLoading(false)
            setDetailId('')
        }).catch(error => {
            setIsLoading(false)
            notify(error?.response?.data?.message)
        })
    })

    return (
        <div>
            <Toaster />
            <div className={`d-flex pointer`} style={{ width: "10px" }} onClick={() => setDetailId("")}>
                <div><RightArrowGrey /></div>
                <p className={`d-flex align-items-center m-0`}
                    style={{ fontSize: "0.8rem", color: "#7a7a7a", paddingRight: "0.1rem" }}
                >بازگشت</p>
            </div>

            <HeaderOfDetail
                title={'مشاهده درخواست مهر سازمانی'}
                text={
                    <div>درخواست گواهی مهر سازمانی با کد ملی
                        <span style={{ fontWeight: "700" }}> {data?.nationalId} </span>
                        و شناسه ملی
                        <span style={{ fontWeight: "700" }}> {data?.companyInfo?.companyNationalId} </span>
                        قابل مشاهده می‌باشد </div>
                }
                traceId={data?.traceId}
                status={data?.transactionStatus}
                cert={data?.certificate}
            />


            <div className={`request-body-div px-4 pt-0 pb-3 mt-4`} style={{ minHeight: "60vh" }}>
                <div className={`d-flex justify-content-center`}><UserHeaderReq /></div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>کد ملی</span>
                    <span>{data?.nationalId}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>نام</span>
                    <span>{data?.firstName}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>نام خانوادگی</span>
                    <span>{data?.lastName}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>نام به انگلیسی</span>
                    <span>{data?.latinFirstName}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>نام خانوادگی به انگلیسی</span>
                    <span>{data?.latinLastName}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>شماره تلفن همراه</span>
                    <span>{data?.phoneNumber}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>استان محل اقامت</span>
                    <span>{data?.province}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>شهر محل اقامت</span>
                    <span>{data?.city}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>آدرس محل اقامت</span>
                    <span>{data?.address}</span>
                </div>

                <div className='row-detail' style={{ border: "none" }}>
                    <span className={`row-detail-span`}>کد پستی محل اقامت</span>
                    <span>{data?.postalCode}</span>
                </div>

            </div>



            {
                data.companyInfo &&
                <FormProvider {...methods}>
                    <form
                        onSubmit={e => e.preventDefault()}
                        noValidate
                        className="container p-0"
                    >

                        <div className={`request-body-div px-4 pt-0 pb-5 mt-4 `} style={{ minHeight: "60vh" }}>
                            <div className={`d-flex justify-content-center`}><CompanyHeaderReq /></div>

                            <div className=' my-4'>
                                <div className='row justify-content-center  mt-3'>
                                    <div className=' border' style={{ "borderRadius": "10px", background: "#fff3f3" }}>

                                        <>
                                            <p className='complete-info-text my-2' style={{ color: "#58152d" }}>راهبر گرامی لطفا به موارد زیر توجه کنید:</p>

                                            {
                                                warningLeader.map((item, index) => (
                                                    <div key={index} className='complete-info-text-row py-2' style={{ color: "#58152d" }}>
                                                        {index + 1} - {item}
                                                    </div>
                                                )

                                                )

                                            }

                                        </>

                                    </div>
                                </div>
                            </div>
                            <p
                                className={`mt-4`}
                                style={{ fontSize: "0.8rem", color: "#212121" }}
                            >لطفا اطلاعات وارد شده شرکت یا سازمان مورد نظر را بررسی و در صورت صحت اطلاعات تایید نموده و در صورت عدم صحت اطلاعات رد کرده و دلیل رد را بنویسید.</p>

                            <CompanyField
                                lable={`نام سازمان`}
                                value={data?.companyInfo?.companyName}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد نام سازمان را بنویسید',
                                    }
                                }}
                                name={'companyNameError'}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`شناسه ملی سازمان`}
                                value={data?.companyInfo?.companyNationalId}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد شناسه ملی سازمان را بنویسید',
                                    }
                                }}
                                name={'companyNationalIdError'}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`نوع سازمان`}
                                value={data?.companyInfo?.companyType === 'Governmental' ? 'دولتی' : 'غیر دولتی'}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد نوع سازمان را بنویسید',
                                    }
                                }}
                                name={'companyTypeError'}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`آدرس`}
                                value={data?.companyInfo?.province + ", " + data?.companyInfo?.city + ", " + data?.companyInfo?.address}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد آدرس را بنویسید',
                                    }
                                }}
                                name={'addressError'}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`شماره تلفن`}
                                value={data?.companyInfo?.phoneNumber}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد شماره تلفن را بنویسید',
                                    }
                                }}
                                name={'phoneNumberError'}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`نام ثبتی انگلیسی سازمان`}
                                value={data?.companyInfo?.latinCompanyName}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد نام ثبتی انگلیسی سازمان را بنویسید',
                                    }
                                }}
                                name={'latinCompanyNameError'}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`تصویر معرفی نامه`}
                                base64String={data?.companyInfo?.introductionLetterImage}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد معرفی نامه را بنویسید',
                                    }
                                }}
                                name={'introductionLetterImageError'}
                                companyName={data?.companyInfo?.companyName}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`تصویر آخرین تغییرات شرکت (روزنامه رسمی)`}
                                base64String={data?.companyInfo?.latestOfficialNewspaperImage}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد تصویر آخرین تغییرات شرکت را بنویسید',
                                    }
                                }}
                                name={'latestOfficialNewspaperImageError'}
                                companyName={data?.companyInfo?.companyName}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`تصوری روی کارت ملی مدیر عامل`}
                                base64String={data?.companyInfo?.managerNationalCardImage}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد تصوری روی کارت ملی مدیر عامل را بنویسید',
                                    }
                                }}
                                name={'managerNationalCardImageError'}
                                companyName={data?.companyInfo?.companyName}
                                transactionStatus={transactionStatus}
                            />

                            <CompanyField
                                lable={`تصویر آگهی تغییرات شرکت (روزنامه رسمی)`}
                                base64String={data?.companyInfo?.establishedNewspaperImage}
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا دلیل رد تصویر آگهی تغییرات شرکت را بنویسید',
                                    }
                                }}
                                name={'establishedNewspaperImageError'}
                                companyName={data?.companyInfo?.companyName}
                                transactionStatus={transactionStatus}
                            />

                        </div>

                        {transactionStatus === "USER_INFORMATION_COMPLETED" &&
                            <>
                                <div className='row justify-content-center my-3 '>
                                    <div className='col-4 me-2'>
                                        <button
                                            onClick={() => setOpenModal(true)}
                                            className='btn w-100 text-form-button'
                                            style={{ "background": "#044448" }}
                                        >
                                            تایید احراز هویت تصویری
                                        </button>
                                    </div>
                                </div>

                                {
                                    data?.ekycCounter >= 10 &&
                                    <div className='row justify-content-center my-3 '>
                                        <div className='col-4 me-2'>
                                            <button
                                                onClick={() => setOpenModalReset(true)}
                                                className='btn w-100 text-form-button'
                                                style={{ "background": "#044448" }}
                                            >
                                                تلاش مجدد برای احراز هویت
                                            </button>
                                        </div>
                                    </div>
                                }
                            </>
                        }

                        {transactionStatus === "SENT_CERT_ISSUED" &&

                            <div className='row justify-content-center my-5 '>
                                <div className='col-4 me-2'>
                                    <button
                                        onClick={() => setOpenModalStatus(true)}
                                        className='btn w-100 text-form-button'
                                        style={{ "background": "#044448" }}
                                    >
                                        بازگشت به مرحله تکمیل اطلاعات
                                    </button>
                                </div>
                            </div>
                        }

                        <div className='row justify-content-center my-5 '>
                            {(transactionStatus === "REJECTED" || transactionStatus === "CHECKING_COMPANY_INFO") &&
                                <div className='col-4 ms-2'>
                                    <button
                                        onClick={onSubmit}
                                        className='btn w-100 text-form-button'
                                        style={{ "background": "#044448" }}
                                    >
                                        ثبت تغییرات
                                    </button>
                                </div>}
                            {data?.certificate && <div className='col-4 me-2'>
                                <button
                                    onClick={() => downloadCsrAsTxt(data?.nationalId, data?.certificate)}
                                    className='btn w-100 text-form-button'
                                    style={{ "background": "#044448" }}
                                >
                                    دانلود گواهی
                                </button>
                            </div>}
                        </div>
                    </form>
                </FormProvider>
            }

            <EkycDonePopUp
                open={openModal}
                setOpen={setOpenModal}
                id={detailId}
                setLoadingPage={setLoadingPage}
            />

            <EkycDoneReset
                open={openModalReset}
                setOpen={setOpenModalReset}
                id={detailId}
                setLoadingPage={setLoadingPage}
            />

            <ChangeTransactionStatusPaid
                open={openModalStatus}
                setOpen={setOpenModalStatus}
                id={detailId}
                setLoadingPage={setLoadingPage}
            />

            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}
        </div>
    )
}